function titleEqul(name) {
    var headings = document.querySelectorAll(name);
    if (!headings.length) return;

    // Reset first so we get natural heights
    headings.forEach((el) => { el.style.minHeight = ''; });

    var maxHeight = 0;
    headings.forEach((el) => {
      if (el.clientHeight > maxHeight) maxHeight = el.clientHeight;
    });

    headings.forEach((el) => {
      el.style.minHeight = maxHeight + 'px';
    });
  }

  function initEqualHeights() {
    var recSection = document.querySelector('.jdgm-carousel__item-container');
    if (!recSection) return;

    var observer = new MutationObserver(function(mutations) {
      var hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
      if (hasNewNodes) {
        setTimeout(function() {
          titleEqul('.jdgm-carousel-item__review-content-wrapper');
        }, 100);
      }
    });

    observer.observe(recSection, { childList: true, subtree: true });
    window.addEventListener('load', function() {
      titleEqul('.jdgm-carousel-item__review-content-wrapper');
    });
  }
  document.addEventListener('DOMContentLoaded', initEqualHeights);